<template>
  <WsMain>
    <WsCRUD
      pageMode
      rowClickRead
      :label="label"
      :fields="fields"
      :sortBy="sortBy"
      :showExpand="false"
      :modelName="modelName"
      :showFields="showFields"
      :filterSelects="filterSelects"
    />
  </WsMain>
</template>

<script>
import model from '@/models/alliance';

export default {
  data() {
    return {
      modelName: model.modelName,
      label: model.label,
      fields: model.fields,
      showFields: [
        'name',
        'area',
      ],
      sortBy: 'sequence',
      filterSelects: [
        {
          type: 'belongsTo',
          label: '',
          textKey: 'name',
          modelName: 'area',
          placeholder: '篩選地區',
          clearable: true,
        },
      ],
    };
  },
};
</script>